<section class="section-container">
  <div class="section-content">
    <div class="welcome">
      <h1>Visualizar proposta</h1>
    </div>

    <app-informacoes-cartao class="informacoes-cartao" [debtValue]="debt?.valorDivida" [nomeProduto]="debt?.nomeProduto" [customerName]="customerData?.nome" [numeroCartaoMascarado]="numeroCartaoMascarado"></app-informacoes-cartao>

    <div class="proposta-foo">
      <div class="propostas-container">
        <h3><strong>Simule uma proposta de acordo</strong></h3>
  
        <div class="propostas-form">
          <mat-form-field appearance="outline" class="select-proposta">
            <mat-label>Selecione uma proposta</mat-label>
            <mat-select  (selectionChange)="showPorpostas = false" [(ngModel)]="propostaSelecionada" placeholder="Selecione uma opção" #selectPlano name="selectPlano">
              <mat-option *ngFor="let proposta of propostas" [value]="proposta">
                {{ proposta.text }}
              </mat-option>
            </mat-select>
    
            <mat-error *ngIf="propostaSelecionada === null || propostaSelecionada === undefined">
              Plano é um campo obrigatório
            </mat-error>
          </mat-form-field>
    
          <button (click)="exibirProposta()" [disabled]="propostaSelecionada === null || propostaSelecionada === undefined" type="button" mat-flat-button color="primary">
            Simular proposta
          </button>
        </div>
      </div>
      
      <div *ngIf="showPorpostas" class="proposta-gerada">
        <h3>Proposta de acordo</h3>
        <div *ngIf="propostaSelecionada.offer.plano > 1; else unico" class="proposta-gerada-info">
          <p>Forma de pagamento: <strong>Parcelado</strong></p>
          <p>Data de vencimento: <strong>{{debt.dataNegociacao| date: 'dd/MM/yyyy'}}</strong></p>
          <p>Valor da entrada: <strong>{{propostaSelecionada.offer.valorEntrada | currencyMask}}</strong></p>
          <p>Parcelas: <strong>{{propostaSelecionada.offer.plano -1}}x {{propostaSelecionada.offer.valorParcela | currencyMask}}</strong></p>
          <p>Valor total do acordo: <strong>{{propostaSelecionada.offer.valorAcordo | currencyMask}}</strong></p>
          <span style="visibility: collapse;"><strong>*A data de vencimento das parcelas será no mesmo dia do vencimento da entrada nos meses
          subsequentes.</strong></span>
        </div>

        <ng-template #unico>
          <p>Forma de pagamento: <strong>À vista</strong></p>
          <p>Previsão de vencimento: <strong>{{debt.dataNegociacao| date: 'dd/MM/yyyy'}}</strong></p>
          <p>Valor da parcela: <strong>{{propostaSelecionada.offer.valorEntrada | currencyMask}}</strong></p>
          <span><strong>*A data de vencimento fornecida é uma previsão. No momento do boleto, essa data pode ser alterada.</strong></span>
        </ng-template>


      </div>

    </div>


    <hr />

    <div class="actions-container">
      <h4>Se deseja prosseguir com a proposta, clique em <strong>‘Contratar acordo’</strong>.</h4>
      <div class="actions">
        <button [disabled]="!showPorpostas" (click)="contratarProposta(propostaSelecionada.offer)" type="button" mat-flat-button color="primary">
          Contratar acordo
        </button>
        <button type="button" (click)="cancelarProposta()" mat-button class="outlined" mat-stroked-button color="primary">
          Cancelar
        </button>
      </div>
    </div> 
  </div>
</section>